<template>
  <div class="page">
    <Header :activeIndex="2" />
    <!-- box1 -->
    <div class="box box1 w">
      <div class="title">
        1.What are the advantages of CNC NC machining technology?
      </div>
      <div class="p1">
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum
          suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan
          lacus vel facilisis.
        </p>
      </div>
      <div class="img_box flex3">
        <img src="../assets/images/technology/t1.jpg" alt="" />
        <div class="content">
          <p>
            ① A large number of tooling is reduced, and complex tooling is not
            needed for parts with complex shapes. To change the shape and size
            of parts, only the part processing procedure needs to be modified,
            which is suitable for the development and modification of new
            products. ② The machining quality is stable, the processing
            precision is high, the repetition precision is high, which is
            suitable for the machining requirements of the aircraft. ③ The
            production efficiency is high under the condition of multi variety
            and small batch production, which can reduce the time of production
            preparation, machine tool adjustment and process inspection, and
            reduce the cutting time due to the use of the best cutting quantity.
            ④ The complex profile which can be processed by conventional methods
            is difficult to process, and even some parts which cannot be
            observed can be processed.
          </p>
          <p>
            The disadvantage of NC machining is that the machine tool equipment
            is expensive, and it requires the maintenance personnel to have a
            high level.
          </p>
        </div>
      </div>
    </div>
    <!-- box2 -->
    <div class="box box2 w">
      <div class="title">
        2. Advantages of CNC milling machine in 5 axis machining?
      </div>
      <div class="p1">
        <p>
          3 axis machining center and vertical machining center are widely used
          in traditional mold processing to complete the workpiece milling. With
          the development of mold manufacturing and processing technology, the
          ball end milling cutter commonly used in traditional mold processing
          has obvious advantages, but if vertical machining center is applied,
          its bottom linear speed is zero and its finish is poor, In this way,
          the weakness of traditional mold processing is gradually revealed. 5
          axis machining can process different sides of the workpiece without
          changing the position of the workpiece on the machine tool, which can
          greatly improve the processing efficiency of prismatic parts. It can
          be used for deep cavity mold, side wall of mold, flat surface and
          irregular surface of mold, different geometry of mold and inclined
          hole on inclined plane of mold. It can reduce the processing time,
          improve the processing accuracy and improve the production efficiency.
        </p>
        <p>
          In the mold processing, the use of 5 axis machining center can avoid
          the interference of cutting tools. It can process the complex parts
          which are difficult to be processed by ordinary 3-axis machine tools.
          For the machining of ruled surface mold, the side milling one tool
          forming technology can be used. The processing quality is good and the
          efficiency is high. For the three-dimensional surface, especially for
          the large and flat surface, it can be processed by the large diameter
          end milling cutter close to the large surface, the number of tool runs
          will be reduced, the residual height is small, and the processing
          efficiency and surface quality can be effectively improved. Multi
          process and multi surface processing can be carried out by clamping
          multiple space surfaces of the die at one time, which can improve the
          processing efficiency and the accuracy of each surface position.
        </p>
      </div>
      <div class="img_box flex3">
        <div class="content">
          <p>
            When the 5 axis machining center is used to process the mold, the
            cutting tool can always be in the most effective cutting state for
            the workpiece. In some machining fields, large-size cutting tools
            can be used to avoid mutual interference. The rigidity of this kind
            of cutting tool is good, and the machining accuracy and efficiency
            can be improved.5 axis machining center can not only complete the
            task of complex workpiece machining, but also improve the machining
            efficiency and shorten the machining process.
          </p>
          The 5 axis machining center adopts the optimized and high rigidity
          structure design, with the machining accuracy of 0.003 mm and the
          positioning accuracy of 5 μ m. The repeat positioning accuracy is 3 μ
          m. It is suitable for the processing of key parts in energy, aviation,
          ship and military industries. It is the only way to solve the
          processing of impellers, blades, marine propellers, heavy generator
          rotors, steam turbine rotors, large diesel engine crankshafts and so
          on. It is no exaggeration to call it a "high-precision" precision
          processing plant.
          <p></p>
          <p>
            Due to the homogenization of manufacturing industry, the competition
            is more and more fierce. Only the unique core technology, under the
            premise of ensuring quality to achieve higher production efficiency,
            or do other people can not high value-added products, can stand out.
            It is in this context that 5 axis machining center is favored by
            more and more manufacturers.
          </p>
        </div>
        <img src="../assets/images/technology/t2.jpg" alt="" />
      </div>
    </div>
    <!-- box3 -->
    <div class="box box3 w">
      <div class="title">3.Features of 5 axis machining center:</div>
      <div class="p1">
        <p>
          Feature 1: symmetrical structure, frame in frame structure and gravity
          center double drive mode are adopted to effectively improve the
          rigidity of the machine tool and suppress vibration. Feature 2:
          improve the machining accuracy, improve the service life of machine
          tool and cutter, and enhance the reliability of machine tool.
        </p>
      </div>
      <div class="img_box flex3">
        <img src="../assets/images/technology/t3.jpg" alt="" />
        <div class="content">
          <p>
            Feature 3: it has the function of on-line programmable control of
            pushing and pulling force of workpiece, which can fully improve the
            internal prestress of workpiece, improve the processing accuracy of
            large thin-walled and slender parts and improve the processing
            yield.
          </p>
          <p>
            Feature 4: equipped with direct drive swing angle milling head,
            larger torque, wider processing range and higher efficiency.
            Equipped with high torque and high precision b-axis, it has higher
            material removal rate than traditional machine.
          </p>
          <p>
            Feature 5: it is equipped with programmable on-line control of the
            pushing and pulling force of the workpiece. The user can realize the
            dynamic servo control of the W-axis through the specific processing
            program instructions, so as to achieve the programmable control of
            the pre tightening pushing and pulling force of the workpiece during
            the part processing.
          </p>
          <p>
            Feature 6: the tool is on three linear axes and the workpiece is on
            two rotary axes, with Zui excellent spindle support; The swing angle
            of axis B is ± one hundred and thirty °， C-axis continuous 360 °
            Spin. The chain type tool magazine is integrated with the machine
            bed, with fast tool changing speed and high reliability.
          </p>
        </div>
      </div>
    </div>
    <!-- box4 -->
    <div class="box box4 w">
      <div class="title">4.What is CNC?</div>
      <div class="p1">
        <p>
          CNC machining is also called Computer Numerical Control machining.
          Before programming, it is necessary to analyze the process of the
          processed parts, draw up the processing plan, select the appropriate
          tool and determine the cutting parameters. In programming, some
          technological problems such as tool setting and machining route need
          to be dealt with. Therefore, the process analysis in programming is
          very important. When processing parts on ordinary machine tools, the
          operation procedure of each process is specified by the process
          specification or process card, and the operator processes the parts
          according to the steps specified in the process card. When machining
          parts on CNC machine tools, it is necessary to program all the
          technological process, technological parameters and displacement data
          to control the machining of machine tools. The processing technology
          of NC machine tool is basically the same as that of ordinary machine
          tool in principle, but the whole process of NC machining is automatic,
          so it has its own characteristics:
        </p>
        <p>
          In the mold processing, the use of 5 axis machining center can avoid
          the interference of cutting tools. It can process the complex parts
          which are difficult to be processed by ordinary 3-axis machine tools.
          For the machining of ruled surface mold, the side milling one tool
          forming technology can be used. The processing quality is good and the
          efficiency is high. For the three-dimensional surface, especially for
          the large and flat surface, it can be processed by the large diameter
          end milling cutter close to the large surface, the number of tool runs
          will be reduced, the residual height is small, and the processing
          efficiency and surface quality can be effectively improved. Multi
          process and multi surface processing can be carried out by clamping
          multiple space surfaces of the die at one time, which can improve the
          processing efficiency and the accuracy of each surface position.
        </p>
      </div>
      <div class="img_box flex3">
        <div class="content">
          <p>1). The content of working procedure is complex</p>
          <p>
            This is because CNC machine tools are more expensive than ordinary
            machine tools. It is not cost-effective to only process simple
            processes, so more complex processes are usually arranged on CNC
            machine tools, and even processes that are difficult to complete on
            ordinary machine tools.
          </p>
          <p>2). The arrangement of working steps is more detailed</p>
          <p>
            This is because the problems that need not be considered in the
            processing technology of ordinary machine tools, such as the
            arrangement of working steps in the process, the determination of
            tool setting point, tool changing point and processing route, can
            not be ignored when compiling the processing technology of CNC
            machine tools.
          </p>
          <p>3). Rely on the program to complete all the process.</p>
          <p>
            4). NC machining program is the directive document of NC machine
            tool.
          </p>
          <p>
            5). CNC machine tools are controlled by program instructions, and
            the whole process of machining is automatically carried out
            according to program instructions.
          </p>
          <p>
            6). NC machining program not only includes the process of parts, but
            also includes the necessary process parameters to complete the
            process, such as cutting parameters, feed route, tool size number
            and machine tool movement process.
          </p>
        </div>
        <img src="../assets/images/technology/t4.jpg" alt="" />
      </div>
    </div>
    <!-- box5 -->
    <div class="box box5 w">
      <div class="title">5.About 3D printing technology</div>
      <div class="p1">
        <p>Advantages of 3D printing technology</p>
        <p>
          (1) Save materials. It does not need to eliminate the leftover
          materials, improves the utilization rate of materials, and reduces the
          cost by abandoning the production line;
        </p>
        <p>
          (2) It can achieve high precision and high complexity, and can
          manufacture very complex parts which can not be manufactured by
          traditional methods;
        </p>
        <p>
          (3) Without traditional tools, fixtures, machine tools or any molds,
          3D CAD graphics of any shape can be directly generated into real
          products;
        </p>
        <p>
          (4) It can automatically, quickly, directly and accurately transform
          the 3D design of computer into physical model, and even directly
          manufacture parts or molds, thus effectively shortening the product
          development cycle;
        </p>
        <p>
          (5) 3D printing has the characteristics of distributed production
          without centralized and fixed manufacturing workshop;
        </p>
        <p>
          (6) 3D printing can take shape in a few hours, which enables designers
          and developers to realize the leap from plan to entity;
        </p>
        <p>
          (7) It can print assembled products, so it can reduce assembly costs
          and even challenge mass production.
        </p>
      </div>
      <div class="img_box1 flex3">
        <div class="left">
          <img src="../assets/images/technology/t5_1.png" alt="" />
          <img src="../assets/images/technology/t5_2.jpg" alt="" />
        </div>
        <div class="content">
          <p>Disadvantages of 3D printing technology</p>
          <p>(1) It has the weakness of high cost and long working hours</p>
          <p>
            3D printing is still an expensive technology. Due to the difficulty
            of research and development of materials for additive manufacturing
            and the small amount of use, the manufacturing cost of 3D printing
            is high, but the manufacturing efficiency is not high.
          </p>
          <p>
            At present, 3D printing technology is mainly used in the research
            and development of new products in China, with high manufacturing
            cost, low manufacturing efficiency and unsatisfactory manufacturing
            accuracy. 3D printing can not replace the traditional manufacturing
            industry at present. In the future development of manufacturing
            industry, "reduced material manufacturing method" is still the
            mainstream.
          </p>
          <p>(2) It has no advantage in large-scale production</p>
          <p>
            Since 3D printing technology has the advantages of distributed
            production, on the contrary, it has no advantages in large-scale
            production. Tianjin Tianyi Duowei Technology Co., Ltd. introduced
            that at present, 3D printing technology does not have the conditions
            to replace the traditional manufacturing industry. In terms of mass
            production and large-scale manufacturing, the traditional reduced
            material manufacturing method with high efficiency and low cost is
            better.
          </p>
          <p>
            Now it seems unlikely that 3D printing will replace mass production.
            Not to mention that 3D printing technology currently does not have
            the ability to directly produce complex mixed material products such
            as automobiles. Even if this technology has made great progress in
            the future, it may take several months to completely print a car,
            and the cost is far higher than the cost shared by each car in the
            mass production of cars.
          </p>
          <p>
            Therefore, for the production of products with a large number of
            rigid demands, the large-scale production with the advantage of
            scale economy is still more economical than the 3D printing
            production mode focusing on "personalization and customization".
          </p>
        </div>
      </div>
      <div class="img_box2 flex3">
        <div class="content">
          <p>(3) Print material restricted</p>
          <p>
            The limitations and bottlenecks of 3D printing technology are mainly
            reflected in materials. At present, the main printing materials are
            plastic, resin, gypsum, ceramics, sand and metal, and the materials
            that can be used for 3D printing are very limited.
          </p>
          <p>
            Although many homogeneous and heterogeneous materials have been
            developed for 3D printing, there is still a need to develop new
            materials, and some new materials are being developed. This demand
            includes two aspects: first, it is necessary to study the
            relationship among materials, processes, structures and properties,
            so as to clarify its advantages and limitations; Second, new testing
            techniques and methods need to be developed to expand the range of
            available materials.
          </p>
          <p>(4) Accuracy and quality issues</p>
          <p>
            Because the inherent forming principle and development of 3D
            printing technology are not perfect, the accuracy (including
            dimensional accuracy, shape accuracy and surface roughness),
            physical properties (such as strength, stiffness, fatigue
            resistance, etc.) and chemical properties of the printed parts can
            not meet the actual use requirements of engineering, and can not be
            used as functional parts, only as prototype parts, So its
            application will be greatly reduced.
          </p>
          <p>
            Moreover, because 3D printing adopts the additive manufacturing
            process of "layered manufacturing, layer by layer superposition", no
            matter how closely the combination between layers is, it can not be
            comparable with the parts cast by traditional mold as a whole, and
            the microstructure and structure of the part materials determine the
            performance of the parts.
          </p>
        </div>
        <img src="../assets/images/technology/t5_3.jpg" alt="" />
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
export default {
  metaInfo: {
    title: '东莞市乔斯精密机械有限公司',
    meta: [
      {
        name: 'keywords',
        content: '东莞市乔斯精密机械有限公司,乔斯,精密,机械',
      },
      {
        name: 'description', // 设置页面描述
        content: '品质用心、技术创新、恪守信誉、追求完美',
      },
    ],
  },
  components: {
    Header,
    Footer,
  },
}
</script>
<style scoped>
.box {
  margin-top: 76px;
}
.box .title {
  font-size: 30px;
  color: #222222;
  text-align: center;
  margin-bottom: 32px;
}
.box .p1 {
  font-size: 16px;
  color: #5d5d5d;
  line-height: 26px;
  margin-bottom: 29px;
}
.box .p1 p {
  /* padding-bottom: 20px; */
}
.box .img_box .content,
.box5 .img_box1 .content,
.box5 .img_box2 .content {
  height: 100%;
  width: 595px;
  background: #2d2d2d;
  font-size: 14px;
  color: #fff;
  padding: 31px 36px;
  overflow: hidden;
  line-height: 26px;
}
.box1 .img_box {
  height: 479px;
}
.box1 .img_box img {
  height: 100%;
  width: 595px;
}
.box2 .img_box {
  height: 570px;
}
.box2 .img_box img {
  height: 100%;
  width: 595px;
}
.box3 .img_box {
  height: 528px;
}
.box3 .img_box img {
  height: 100%;
  width: 528px;
}
.box4 .img_box {
  height: 603px;
}
.box4 .img_box img {
  height: 100%;
  width: 603px;
}
.box5 {
  margin-bottom: 64px;
}
.box5 .img_box1 {
  height: 644px;
  margin-bottom: 17px;
}
.box5 .img_box1 .left {
  height: 100%;
  width: 338px;
}
.box5 .img_box1 .left img {
  width: 338px;
  height: 319px;
  margin-bottom: 6px;
}
.box5 .img_box1 .content {
  width: 843px;
}
.box5 .img_box2 {
  height: 570px;
}
.box5 .img_box2 .content {
  width: 747px;
}
.box5 .img_box2 img {
  height: 100%;
  width: 442px;
}
</style>


// WEBPACK FOOTER //
// src/views/technology.vue